import { Injectable } from '@angular/core';
import { CompanyActions, CompanySelectors, StateWithCompany } from '@company/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { ActivatedRouterStateSnapshot, AuthService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class SaveCompanyEffects {
  resetSavedCompanyWhenLeaveLoginPage$: Observable<CompanyActions.ResetSavedCompany> = createEffect(() =>
    this.actions$.pipe(
      ofType<RouterNavigatedAction<ActivatedRouterStateSnapshot>>(ROUTER_NAVIGATED),
      concatLatestFrom(() => [this.store.select(CompanySelectors.getSavedCompany), this.authService.isUserLoggedIn()]),
      filter(
        ([action, savedCompany, isLoggedIn]) =>
          action.payload.routerState.semanticRoute !== 'login' && !!savedCompany && !isLoggedIn,
      ),
      map(() => new CompanyActions.ResetSavedCompany()),
    ),
  );

  resetSavedCompanyAfterAddSuccess$: Observable<CompanyActions.ResetSavedCompany> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.AddCompanySuccess>(CompanyActions.ADD_COMPANY_SUCCESS),
      concatLatestFrom(() => this.store.select(CompanySelectors.getSavedCompany)),
      filter(([, data]) => Boolean(data)),
      map(() => new CompanyActions.ResetSavedCompany()),
    ),
  );

  resetSavedCompanyAfterAddFail$: Observable<CompanyActions.ResetSavedCompany> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.AddCompanyFail>(CompanyActions.ADD_COMPANY_FAIL),
      concatLatestFrom(() => [this.store.select(CompanySelectors.getSavedCompany), this.authService.isUserLoggedIn()]),
      filter(([, data, isLoggedIn]) => Boolean(data) && isLoggedIn),
      map(() => new CompanyActions.ResetSavedCompany()),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<StateWithCompany>,
    private authService: AuthService,
  ) {}
}
